module.exports = __webpack_public_path__ + "img/No_TrackAndTrace.b6dbd4a4.svg";